import { render, staticRenderFns } from "./Clock.vue?vue&type=template&id=75f56967"
import script from "./Clock.vue?vue&type=script&lang=ts"
export * from "./Clock.vue?vue&type=script&lang=ts"
import style0 from "./Clock.vue?vue&type=style&index=0&id=75f56967&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports